import { Center, Loader as MantineLoader, Stack, Text } from '@mantine/core';

/** A full-page wait before there is a shell to put a page in. */
export const Loader = ({ message }: { message?: string }) => (
    <Center h="100vh">
        <Stack align="center" gap="sm">
            <MantineLoader />
            {message && <Text fz="sm" c="dimmed">{message}</Text>}
        </Stack>
    </Center>
);
